module.exports = {
      id: "heart_rate-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#heart_rate-usage",
      toString: function () {
        return this.url;
      }
    }